import { Buffer } from 'buffer';

/**
 * Decodes a string of Base64-encoded data into bytes, and encodes those bytes into a string using Latin-1 (ISO-8859).
 * window.atob is deprecated. Use `Buffer.from(data, 'base64')` instead.
 * @param str The Base64-encoded input string.
 */
export const fromBase64 = (str: string) => Buffer.from(str, 'base64').toString('binary');

/**
 * Decodes a string into bytes Latin-1 (ISO-8859), and encodes those bytes into a string using Base64.
 * window.btoa is deprecated. Use `buf.toString('base64')` instead.
 * @param str An ASCII (Latin1) string.
 */
export const toBase64 = (str: string) => Buffer.from(str, 'binary').toString('base64');
